import { render, staticRenderFns } from "./Commens.vue?vue&type=template&id=30ca7479"
import script from "./Commens.vue?vue&type=script&lang=ts"
export * from "./Commens.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports